import React from 'react';

import ImportShow from '@components/shared/imports/ImportShow';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { useLoaderData } from 'react-router-dom';

export default function OperatorImportShow() {
  const importData = useLoaderData();
  const { merchants } = useOperatorData();

  return (
    <ImportShow
      importData={importData}
      role="operator"
      merchants={merchants}
    />
  );
}
